import React, {useEffect, useRef, useState} from "react";
import "./style.scss";
import {usePagination, useTable} from "react-table";
import CalenderIcon from "../../../../assets/icons/calender.svg";
import Search from "../../../../assets/icons/search.svg";
import CreateIcon from "../../../../assets/icons/add-circle.svg";

import CaretLeftIcon from "../../../../assets/icons/caret-left.svg";
import CaretRightIcon from "../../../../assets/icons/caret-right.svg";
import {Link, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import CopyToClipboard from "react-copy-to-clipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {baseUrl} from "../../../../utils/apis";
import {Tooltip} from "@mui/material";
import ReactTable from "../../../ReactTable/ReactTable";

function OverviewTable() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const openModal = (content) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setModalContent(null);
    setIsModalOpen(false);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      marginTop: "4px",
      height: 48,
      borderRadius: 8,
      border: "none",
      boxShadow: "none",
      paddingRight: "20px",
      fontFamily: "DM Sans , sans-serif",
      fontSize: "14px",
      fontWeight: 700,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
    }),
  };
  const [isChallengeDropdown, setChallengeDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !event.target.classList.contains("column_header")) {
        setChallengeDropdown(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);
  const idToken = useSelector((state) => state.auth.idToken);
  const [codeList, setCodeList] = useState([]);
  

  useEffect(() => {
    let config = {
      headers: {
        Authorization: "Bearer " + idToken,
      },
    };
    axios
      .get(`${baseUrl}/affiliates/list/`, config)
      .then((res) => {
        setCodeList(res.data.data);
      })
      .catch((err) => {});
  }, [idToken]);

  const data = React.useMemo(() => codeList, [codeList]);
  const navigate = useNavigate();
  const handleCheckStatus = (id) => {
    navigate(`/affiliate-list/${id}`);
  };
  const truncateString = (inputString, maxLength) => {
    const formattedString = inputString.toString();
    if (formattedString.length > maxLength) {
      return inputString.toString().substring(0, maxLength) + "...";
    }
    return inputString;
  };

  const handleCopyToClipboard = (text) => {
    toast("Text copied to clipboard !", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      type: "success",
      theme: "dark",
      className: "custom-toast-container",
    });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Code",
        accessor: "code",
        Cell: ({row}) => (
          <div
            // onClick={() => handleCheckStatus(row.original.id)}
            className="column_one_wrapper_test"
          >
            <div className="side_lines">
              <div>{row.original.code}</div>
            </div>
          </div>
        ),
      },
      {
        Header: (
          <>
            {/* <div className="column_header"> */}
            Discount %{/* <img src={vectorIcon} alt="arrow-down" />{" "} */}
            {/* </div> */}
          </>
        ),
        accessor: "percentage",
        Cell: ({row}) => (
          <div
            // onClick={() => handleCheckStatus(row.original.id)}
            style={{width: "120px"}}
          >
            {row.original.percentage}%
          </div>
        ),

        //   sortType: "login_id",
      },
      {Header: "Signups", accessor: "pushed_leads"},
      {
        Header: "Url",
        accessor: "url",
        Cell: ({row}) => {
          return (
            <div
              className="url"
              style={{display: "flex", width: "82%", alignItems: "center"}}
            >
              {" "}
              <Tooltip
                title={<span style={{fontSize: "14px"}}>{row.original.url}</span>}
                placement="top"
                arrow="bottom"
                style={{display: "flex", alignItems: "center"}}
              >
                <b
                  className="url-content"
                  style={{paddingRight: "10px"}}
                >
                  {row.original.url}
                </b>
                <CopyToClipboard
                  onCopy={handleCopyToClipboard}
                  text={row.original?.url}
                >
                  {/* <button> */}
                  <p
                    className="table_copy_button"
                    style={{
                      marginRight: "20px",
                      // backgroundColor: "#35d269",
                      cursor: "pointer",
                    }}
                    // onClick={() => handleCopyToClipboard(row.original?.payment_id)}
                  >
                    {/* <ContentCopyIcon sx={{fontSize: "20px", backgroundColor: "#35d269", color: "black"}} /> */}
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="24"
                        height="24"
                        rx="12"
                        fill="#071E0D"
                      />
                      <path
                        d="M17.886 12.574C18 12.2987 18 11.9487 18 11.25C18 10.5513 18 10.2013 17.886 9.926C17.8106 9.74395 17.7001 9.57854 17.5608 9.43922C17.4215 9.29989 17.256 9.18938 17.074 9.114C16.7987 9 16.4487 9 15.75 9H11.4C10.56 9 10.14 9 9.81933 9.16333C9.53684 9.30719 9.30719 9.53684 9.16333 9.81933C9 10.1393 9 10.5593 9 11.4V15.75C9 16.4487 9 16.7987 9.114 17.074C9.26667 17.4413 9.55867 17.734 9.926 17.886C10.2013 18 10.5513 18 11.25 18C11.9487 18 12.2987 18 12.574 17.886M17.886 12.574C17.8106 12.756 17.7001 12.9215 17.5608 13.0608C17.4215 13.2001 17.256 13.3106 17.074 13.386C16.7987 13.5 16.4487 13.5 15.75 13.5C15.0513 13.5 14.7013 13.5 14.426 13.614C14.244 13.6894 14.0785 13.7999 13.9392 13.9392C13.7999 14.0785 13.6894 14.244 13.614 14.426C13.5 14.7013 13.5 15.0513 13.5 15.75C13.5 16.4487 13.5 16.7987 13.386 17.074C13.3106 17.256 13.2001 17.4215 13.0608 17.5608C12.9215 17.7001 12.756 17.8106 12.574 17.886M17.886 12.574C17.5275 13.8107 16.8678 14.9391 15.9661 15.8582C15.0645 16.7774 13.9489 17.4585 12.7193 17.8407L12.574 17.886M15 9V8.4C15 7.56 15 7.14 14.8367 6.81933C14.693 6.53694 14.4636 6.3073 14.1813 6.16333C13.86 6 13.44 6 12.6 6H8.4C7.56 6 7.14 6 6.81933 6.16333C6.53684 6.30719 6.30719 6.53684 6.16333 6.81933C6 7.13933 6 7.55933 6 8.4V12.6C6 13.44 6 13.86 6.16333 14.1807C6.30733 14.4633 6.53667 14.6927 6.81933 14.8367C7.13933 15 7.56 15 8.40067 15H9"
                        stroke="#36D66B"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </p>
                  {/* </button> */}
                </CopyToClipboard>
              </Tooltip>
            </div>
          );
        },
        className: "url_address",
      },
      {Header: "Percentage", accessor: "percentage_repeat"},
      {Header: "Used by", accessor: "consumed_by_count"},
    ],
    [],
  );

  return (
    <div className="overview_table">
      <div className=" table_wrapper">
        <div className="table_header">
          {/* <div className="search">
            <div className="search_bar">
              <input
                type="text"
                className="search_input"
                placeholder="Search..."
              />
              <img
                className="search_icon"
                src={Search}
                alt="search icon"
              />
            </div>
            <img
              className=""
              src={CalenderIcon}
              alt="calender icon"
            />
          </div> */}
          <h2>Affiliate Codes</h2>
          <Link to="/affiliate/get-a-link">
            {" "}
            <div className="create_wrapper">
              <img
                className="create_icon"
                src={CreateIcon}
                alt="create"
              />
              <p>Create Affiliate Code</p>
            </div>{" "}
          </Link>
        </div>
        <div className="table_scroll_wrapper">
          {/* <Table openModal={openModal} /> */}
          <ReactTable
            columns={columns}
            data={data}
          />
        </div>
        <ModalPopup
          isModalOpen={isModalOpen}
          modalContent={modalContent}
          openModal={openModal}
          closeModal={closeModal}
        />
      </div>{" "}
      <ToastContainer />
    </div>
  );
}

export default OverviewTable;

const ModalPopup = ({isModalOpen, modalContent, closeModal}) => {
  if (!isModalOpen) {
    return null;
  }

  return (
    <div className="modal">
      <div className="modal-content">
        <button
          className="close"
          onClick={closeModal}
        >
          &times;
        </button>
        <h2>Referred List</h2>
        <p>{modalContent}</p>
      </div>
    </div>
  );
};
